import { render, staticRenderFns } from "./CustomersOverview.vue?vue&type=template&id=7490f2d7&scoped=true"
import script from "./CustomersOverview.vue?vue&type=script&lang=js"
export * from "./CustomersOverview.vue?vue&type=script&lang=js"
import style0 from "./CustomersOverview.vue?vue&type=style&index=0&id=7490f2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7490f2d7",
  null
  
)

export default component.exports